import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "ModelReference"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M3.00006 15.75V17.25H5.68956L1.50006 21.4395L2.56056 22.5L6.75006 18.3105V21H8.25006V15.75H3.00006ZM6.37511 3H17.6251L22.7131 9.78375L12.0001 22.1453L7.72661 10.5H3.89261L6.15086 13.1055L5.15786 14.25L1.28711 9.78375L1.87511 9L6.37511 3ZM16.1656 9H20.2501L16.8751 4.5H13.3531L16.1656 9ZM9.60314 9.00001L12.0001 5.16526L14.3971 9.00001H9.60314ZM7.12506 4.5L3.75006 9H7.83456L10.6471 4.5H7.12506ZM11.9994 17.7907L9.32415 10.5H14.6762L11.9994 17.7907ZM16.2737 10.5L13.4575 18.1732L20.1077 10.5H16.2737Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/ModelReference.vue"]]);
